<script>
export default {
  data() {
    return {};
  },
};
</script>

<template>
  <BaseButton
    type="button"
    class="btn-secondary btn-round btn-add-more"
    @click="$emit('show-exercise-list')"
  >
    <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-curl'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.18 7.87c2.032 0 3.678-1.761 3.678-3.935C7.858 1.762 6.212 0 4.181 0S.503 1.762.503 3.935c0 2.174 1.647 3.936 3.678 3.936zm0-2.66c.678 0 1.226-.595 1.226-1.33 0-.735-.548-1.33-1.225-1.33s-1.226.595-1.226 1.33c0 .735.549 1.33 1.226 1.33zM.125 10.03a2.07 2.07 0 00.172 1.77l5.737 9.528a1.694 1.694 0 002.487.467l9.845-7.607A4.974 4.974 0 0020.29 9.98l-.032-.577a4.186 4.186 0 00-3.726-3.932 4.279 4.279 0 00-4.018 1.872L7.387 15 2.786 9.304a1.487 1.487 0 00-2.555.428l-.107.297z" fill="#000"/></svg>
    Add Another Exercise
  </BaseButton>
</template>

<style lang="scss" scoped>
@import '@design';

.btn-add-more {
  margin-bottom: 0;
  padding: 0.8rem 2rem;

  &:focus,
  &:active {
    padding: 0.8rem 2rem !important;
  }

  .icon-curl {
    width: 1.4rem;
  }
}
</style>
